const api = {
    GET_USER_LIST: "/api/usermanagement/list",
    GET_USER: "/api/usermanagement/get",
    ADD_USER: "/api/usermanagement/add",
    UPDATE_USER: "/api/usermanagement/edit",
    DELETE_USER: "/api/usermanagement/delete",
    CHANGE_ACTIVITY: "/api/usermanagement/useractivity"
}

export default api;
